import { render, staticRenderFns } from "./navbar-router.vue?vue&type=template&id=94c94ff4"
import script from "./navbar-router.vue?vue&type=script&lang=js"
export * from "./navbar-router.vue?vue&type=script&lang=js"
import style0 from "./navbar-router.vue?vue&type=style&index=0&id=94c94ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports